import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ResultHuayCardNormal, {
  ResultHuayCardThai,
  ResultHuayYeekee,
  ResultHuayCardJackPot
} from "../component/ResultLotteryCard";
import { getResultLottery, getResultLotteryYeekee, getResultLotteryFromDate } from "../features/resultlotteryReducer";
import DatePicker from "react-multi-date-picker"
import PreviousBar from "../component/PreviousBar";

const Resultlottery = () => {
  const deleteKey = (Data) => {
    // console.log(Data)
    // console.log(Object.keys(Data ? Data : []))
    var res = []
    if (Object.keys(Data ? Data : [])[0] != "0") {
      for (let i in Data) {
        res.push(Data[i])
      }
      return res
    } else {
      return Data
    }
  }

  const getResultLotteryByGroup = (data, name) => {
    // console.log(data,name)
    let result = []
    for (let index = 0; index < data.length; index++) {
      if (data[index].lotteryName == name || data[index].group == name) {
        result.push(data[index])
      }
    }
    return result
  }

  const resultLottery = useSelector(state => state.result.resultLottery)
  const resultLotteryYeekee = useSelector(state => state.result.resultLotteryYeekee)
  // console.log(resultLotteryYeekee.sort((a, b) => a.roundNumber - b.roundNumber))
  const ResultTotal = deleteKey(resultLottery)
  const [date, setDate] = useState(new Date())
  const dispatch = useDispatch()

  const handleChange = (value) => {
    setDate(value)
    dispatch(getResultLotteryFromDate(value))
    dispatch(getResultLotteryYeekee(value))
  }

  useEffect(() => {
    dispatch(getResultLottery())
    dispatch(getResultLotteryYeekee(date))
  }, [])

  return (
    <div className="pb-10 md:pb-20">
      <PreviousBar name="ตรวจผลรางวัล" toDashboard/>
      <div className="flex justify-end mx-1">
        <DatePicker inputClass="w-auto text-center text-[#b3853e] bg-[#f8eede] mt-3 rounded border border-[#b3853e] outline-none" format={'DD/MM/YYYY'} value={date} onChange={handleChange} />
      </div>
      
      <div className="grid grid-cols-1">
        <ResultHuayCardJackPot date={date} lotteryName="หวยแจ็คพอต" result={getResultLotteryByGroup(ResultTotal, "หวยแจ็คพอต")} />
      </div>
      <div className="grid grid-cols-1">
        <ResultHuayCardJackPot date={date} lotteryName="หวยลาว SUPER" result={getResultLotteryByGroup(ResultTotal, "หวยลาว SUPER")} />
      </div>
      <div className="grid grid-cols-1">
        <ResultHuayCardThai date={date} lotteryName="หวยรัฐบาลไทย" result={getResultLotteryByGroup(ResultTotal, "หวยรัฐบาลไทย")} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-1 md:mt-1">
        <ResultHuayCardNormal date={date} lotteryName="หวย ธกส" result={getResultLotteryByGroup(ResultTotal, 'หวย ธกส')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยออมสิน" result={getResultLotteryByGroup(ResultTotal, 'หวยออมสิน')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยลาว" result={getResultLotteryByGroup(ResultTotal, 'หวยลาว')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยลาวสตาร์" result={getResultLotteryByGroup(ResultTotal, 'หวยลาวสตาร์')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยฮานอย" result={getResultLotteryByGroup(ResultTotal, 'หวยฮานอย')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยฮานอยพิเศษ" result={getResultLotteryByGroup(ResultTotal, 'หวยฮานอยพิเศษ')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยฮานอย VIP" result={getResultLotteryByGroup(ResultTotal, 'หวยฮานอย VIP')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยมาเลย์" result={getResultLotteryByGroup(ResultTotal, 'หวยมาเลย์')} />
      </div>
      <p className="text-l text-[#b3853e] font-bold mt-4 px-2">หวยหุ้นต่างประเทศ</p>
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-1">
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นนิเคอิรอบเช้า" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นนิเคอิรอบเช้า')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นจีนรอบเช้า" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นจีนรอบเช้า')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นฮั่งเส็งรอบเช้า" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นฮั่งเส็งรอบเช้า')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นไต้หวัน" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นไต้หวัน')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นนิเคอิรอบบ่าย" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นนิเคอิรอบบ่าย')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นเกาหลี" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นเกาหลี')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นจีนรอบบ่าย" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นจีนรอบบ่าย')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นฮั่งเส็งรอบบ่าย" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นฮั่งเส็งรอบบ่าย')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นสิงคโปร์" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นสิงคโปร์')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นอินเดีย" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นอินเดีย')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นอียิปต์" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นอียิปต์')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นรัสเซีย" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นรัสเซีย')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นอังกฤษ" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นอังกฤษ')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นเยอรมัน" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นเยอรมัน')} />
        <ResultHuayCardNormal date={date} lotteryName="หวยหุ้นดาวน์โจน" result={getResultLotteryByGroup(ResultTotal, 'หวยหุ้นดาวน์โจน')} />
      </div>
      <ResultHuayYeekee lotteryName="จับยี่กี" date={date} result={resultLotteryYeekee ? getResultLotteryByGroup(resultLotteryYeekee, 'จับยี่กี') : []} />
      <ResultHuayYeekee lotteryName="จับยี่กี 5G" date={date} result={resultLotteryYeekee ? getResultLotteryByGroup(resultLotteryYeekee, 'จับยี่กี 5G') : []} />
    </div>
  );
}

export default Resultlottery